(function ($) {

  if ( $(".site-main").hasClass("fmp-outplacement-page") || $(".site-main").hasClass("fmp-contact") ) {
    $(".fmp-outplacement-chat-form__input-wrap").on("click, focus", ".input-text", function(e){
      $(this).closest('.fmp-outplacement-chat-form__input-wrap').addClass("focused");
    });

    $(".fmp-outplacement-chat-form__input-wrap").on("focusout", ".input-text", function(e){
      var value = $(this).val();
      if( "" === value ){
        $(this).closest('.fmp-outplacement-chat-form__input-wrap').removeClass("focused");
      }
    });

    $('.wpcf7-text, .wpcf7-textarea').on('focus focusout', function(e) {
      var fieldName = $(this).attr('name');
      var fieldValue = $(this).val().trim();

      if('focusout' === e.type){
        if(!fieldValue){
          fmpIsRequiredField(this, fieldName, fieldValue);
        }else{
          if('email' == fieldName){
            fmpIsEmailField(this, fieldName, fieldValue);
          }
          if('phone_number' == fieldName){
            fmpIsPhoneNumberField(this, fieldName, fieldValue);
          }
        }
      }else{
        $(this).parent().find(".error").remove();
      }

    });

    function fmpIsRequiredField(selector, fieldName, fieldValue){
      if( !fieldValue){
        if('full_name' == fieldName) {
          $(selector).addClass('wpcf7-not-valid');
          if ( $(selector).is("#chat_form_name") ) {
            $(selector).after('<span class="error" aria-hidden="true">Name is required.</span>');
          }else {
            $(selector).after('<span class="error" aria-hidden="true">Full Name is required.</span>');
          }
        }else if('email' == fieldName){
          $(selector).addClass('wpcf7-not-valid');
          if ( $(selector).is("#chat_form_email") ) {
            $(selector).after('<span class="error" aria-hidden="true">Email is required.</span>');
          }else {
            $(selector).after('<span class="error" aria-hidden="true">Email address is required.</span>');
          }
        }else if('phone_number' == fieldName){
          $(selector).addClass('wpcf7-not-valid');
          $(selector).after('<span class="error" aria-hidden="true">Phone number is required.</span>');
        }else if('company' == fieldName){
          $(selector).addClass('wpcf7-not-valid');
          $(selector).after('<span class="error" aria-hidden="true">Company name is required.</span>');
        }else if('subject' == fieldName){
          $(selector).addClass('wpcf7-not-valid');
          $(selector).after('<span class="error" aria-hidden="true">Subject is required.</span>');
        }else if('message' == fieldName){
          $(selector).addClass('wpcf7-not-valid');
          if ( $(selector).is("#chat_form_message") ) {
            $(selector).after('<span class="error" aria-hidden="true">Brief description is required.</span>');
          }else {
            $(selector).after('<span class="error" aria-hidden="true">Message is required.</span>');
          }
        }
      }
    }

    function fmpIsEmailField(selector, fieldName, fieldValue){
      var regex = /^([a-zA-Z0-9_\.\-\+])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
      if (!regex.test(fieldValue)) {
        $(selector).addClass('wpcf7-not-valid');
        $(selector).after('<span class="error" aria-hidden="true">Email is invalid.</span>');
      }else{
        $(selector).removeClass('wpcf7-not-valid');
        $(selector).parent().find('.error').remove();
      }
    }

    function fmpIsPhoneNumberField(selector, fieldName, fieldValue){
      phoneNumber = fieldValue.replace(/[^A-Z0-9]/ig,'');
      var regex = /^\d+$/;
      if (!regex.test(phoneNumber)) {
        $(selector).addClass('wpcf7-not-valid');
        $(selector).after('<span class="error" aria-hidden="true">Phone number is invalid.</span>');
      }else{
        $(selector).removeClass('wpcf7-not-valid');
        $(selector).parent().find('.error').remove();
      }
    }

  }

})(jQuery);
